module.exports = __webpack_public_path__ + "img/logo.8495d15b.png";